import { useTruckInfo } from '../../../../../../Hooks/TT_ELD/TruckInfo';
import { useParams } from 'react-router-dom';
import TruckAllInfo from './TruckInfoTable/TruckInfo/TruckAllInof';
import { Card, Empty } from 'antd';

interface Data {
  data?: {
    data: Array<any>;
    count: number;
  };
  isLoading?: boolean;
}

type params = {
  readonly id: any;
};
const TruckInfo = () => {
  const { id } = useParams<params>();

  const { data, isLoading }: Data = useTruckInfo(id);

  return (
    <>
      <Card loading={isLoading}>
        <TruckAllInfo data={data?.data} />
      </Card>
    </>
  );
};

export default TruckInfo;
